import { useQuery } from '@apollo/client/react'

import { QUERY_ACCOUNT } from '../common/graphql/account'
import type { AccountQuery } from '../gql/graphql'

/**
 * Account shape actually selected by QUERY_ACCOUNT — a subset of the schema
 * `Account` type. Consumers must only rely on fields present in the query
 * selection; anything else is undefined at runtime.
 */
export type QueryAccount = AccountQuery['account']

export function useAccount(): {
  account: QueryAccount | undefined
  loading: boolean
} {
  const { data, loading } = useQuery(QUERY_ACCOUNT, {
    fetchPolicy: 'cache-first',
    errorPolicy: 'all',
  })

  return {
    account: data?.account,
    loading,
  }
}
